import React, {useState, useEffect} from 'react'
import styled from 'styled-components';
import logo from '../images/MegaPlazaBuilding.jpg';
import {Add, Remove} from '@material-ui/icons';
import { addPaymentVoucher } from '../redux/pvSlice';
import { useDispatch } from 'react-redux';
import { currentDateLocale, dateAsLocaleString } from '../utils/currentDate';
import { delay } from '../utils/delay';
import { useSelector } from 'react-redux';
import { mobile } from '../responsive';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { dateAsYYMM } from '../utils/currentDate';
import { updateProjectVoucherCount } from '../redux/projectSlice';

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    ),
    url(${logo})
      center;
      
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
`;

const Wrapper = styled.div`
    width: 60vw;
    padding: 20px;
    background-color: white;
    display: flex;
    align-items:center;
    justify-content: space-around;
    flex-direction: column;
    border-radius: 10px;
    box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
                -10px -10px 30px rgba(9, 148, 255, 0.1), 
                inset -5px -5px 15px rgba(9, 148, 255, 0.5);
    ${mobile({ width: '70vw' })};
    
 
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 300;
  text-decoration: underline;
  text-underline-offset: 4px;
  text-decoration-color: gray;
  text-align: center;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  /*flex-wrap: wrap;*/
`;

const InputContainer = styled.div`
    flex: 3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 20px;
    
    ${mobile({ flexWrap: 'wrap',
                margin: 0,
                justifyContent: 'center'
             })};
`

const Input = styled.input`
  flex: 1;
  /*min-width: 40%;*/
  margin: 0px 0px 0px 5px;
  padding: 10px;
  border-radius: 5px;
    border: none;
   
    box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
    -10px -10px 30px rgba(9, 148, 255, 0.1), 
    inset -5px -5px 15px rgba(9, 148, 255, 0.5);
    
    &:hover, &:focus {
        box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);

    }

  ${mobile({ minWidth: '60vw', 
             margin: '5px 0'
            })};
`;


const Button = styled.button`

    border: none;
    padding: 15px 20px;
    color: white;
    cursor: pointer;
    flex: 1;

    margin: 30px 20px;
    border-radius: 10px;
    background: rgba(0, 200, 200, 0.9);
    font-size: 20px;
    font-weight: bold;
    box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                inset 0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                inset -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);
    
  &:hover{
    background: rgb(9,104,121);
    background: linear-gradient(126deg, rgba(9,104,121,1) 39%, 
        rgba(6,97,166,1) 60%, rgba(0,83,251,0.49763655462184875) 100%);
    box-shadow: none;
    }
  ${mobile({ 
        width: '70vw'
      })};
`;


const FormRow = styled.div`
    
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
  ${mobile({ 
        width: '70vw',
        flexWrap: 'wrap', 
        margin: 0
      })};

`;

const FormRowTitle = styled.span`
  font-size: 18px;
  font-weight: 200;
  flex: 1;
  padding: 10px;
`;

const DropDownSelect = styled.select`
  flex: 3;
  padding: 10px;

  border-radius: 5px;
  border: none;
  box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
    -10px -10px 30px rgba(9, 148, 255, 0.1), 
    inset -5px -5px 15px rgba(9, 148, 255, 0.5);
    
    &:hover, &:focus {
        box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);
    }
    

  ${mobile({ minWidth: '60vw'
            })};
`;

const DropDownOption = styled.option``;

const SuccessMessageBox = styled.h1`
  font-size: 20px;
  font-weight: 300;
  color: ${(props) => props.color};
`;

const DateContainer = styled.div`
   flex: 3;
`
const StyledDatePicker = styled(DatePicker)`
    width: 95%;
    
    padding: 10px;
    border-radius: 5px;
    border: none;
    box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
        -10px -10px 30px rgba(9, 148, 255, 0.1), 
        inset -5px -5px 15px rgba(9, 148, 255, 0.5);
        
    &:hover, &:focus {
        box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);
    }
        

    ${mobile({ 
                minWidth: '60vw'
            })};
`

const CreateVoucher = () => {

    const pvModelInitState = {
        'dept' : '',
        'section' : '',
        'location' : '',
        'payee' : '',
        'payeeId' : 0,
        'paymode' : '',
        'bank' : '',
        'acctno' : '',
        'voucherDate' : new Date(),
        'voucherDateStr' : '',
        'project' : '',
    };

    const acctDetailsInitState = {
        'bank' : '',
        'acctno' : ''
    };

    const currItemInitState = {
        'itemdesc' : '',
        'itemamount' : 0
    }

    const [pvModel, setPvModel] = useState(pvModelInitState);
    const [pvItems, setPvItems] = useState([]);
    const [currItem, setCurrItem] = useState(currItemInitState);
    const [showNewItem, setShowNewItem] = useState(true);
    const [totalAmount, setTotalAmount] = useState(0);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [acctDetails, setAcctDetails] = useState(acctDetailsInitState);
    
    const dispatch = useDispatch();
    const pv = useSelector(state => state.pv);
    const dept = useSelector(state => state.dept);
    const payeeRedux = useSelector(state => state.payeeRedux);
    const sectionRedux = useSelector(state => state.sectionRedux);
    const locationRedux = useSelector(state => state.locationRedux);
    const bankRedux = useSelector(state => state.bankRedux);
    const projectRedux = useSelector(state => state.projectRedux);

    const resetStates = () => {
        setPvModel({...pvModelInitState});
        setPvItems([]);
        setCurrItem({...currItemInitState});
        setShowNewItem(true);
        setTotalAmount(0);
        setSuccessMessage('');
        setErrorMessage('');
        setAcctDetails({...acctDetailsInitState});
    };

    const generateVoucherNo = (serialno) => {
        const currDateStr = dateAsYYMM(pvModel.voucherDate);
        return currDateStr + serialno.toString().padStart(4, '0');
    };

    const getNextAvailableId = () => {
        return pv && pv.vouchers && pv.vouchers.length > 0 
            ? pv.vouchers[pv.vouchers.length - 1].serialNo + 1 : 1;
        
    };

    const handleInputChange = (e) => {
        const {name, value} = e.target;

        if(name === 'payee'){
            const payee = payeeRedux?.payees.filter((item) => item.payeeId === Number(value));
            
            const {payeeAcct, payeeBank, payeeName} = payee[0];
            setAcctDetails({'bank' : payeeBank, 'acctno' : payeeAcct});
            setPvModel({...pvModel, [name] : payeeName, 'payeeId' : Number(value), 'bank' : payeeBank, 'acctno' : payeeAcct });
        }

        else if(name === 'voucherDate'){
           
            setPvModel({...pvModel, [name]: value, 'voucherDateStr' : dateAsLocaleString(value)});
        }
        
        else{
            if(name === 'bank' || name === 'acctno'){
                setAcctDetails({...acctDetails, [name] : value});
            }
            setPvModel({...pvModel, [name] : value});
        }

        
        

    }

    const handleItemChange = (e) => {
        const {name, value} = e.target;
        setCurrItem({...currItem, [name] : value});
        //setPvItems([...pvItems, {[name] : value}]);
    }


    const handleItemAdd = (e) => {
        e.preventDefault();
        if(currItem?.itemdesc && currItem?.itemamount){
            setPvItems([...pvItems, currItem]);
            setCurrItem(() => ({}));
            setShowNewItem(false);
            setTotalAmount((prev) => prev + Number(currItem.itemamount));
        }
        
    }

    const handleItemRemove = ({index}) => {
        const filteredPVItems = pvItems?.filter((item, indx) => (indx !== index));
        setPvItems([...filteredPVItems]);
        
    }

    const handleSubmit = async (e) => {
        /*
        To DO - Add required save logic
        */
        e.preventDefault();
        //setPvModel({...pvModel, 'pv-items' : pvItems});
        console.log({pvModel}, {pvItems}, {currItem});
        //validate
        const { dept, payee, paymode, section, location, bank, project } = pvModel;
        const canPersist = (dept && dept !== 'Select Department') 
                            && (payee && payee !== 'Select Payee') 
                            && (paymode && paymode !== 'Select Payment Mode') 
                            && (section && section !== 'Select Section') 
                            && (location && location !== 'Select Location')
                            && (project && project !== 'Select Project') 
                            && pvItems.length > 0; 
        
        if(canPersist) {
            console.log('all correct');
            const sNo = getNextAvailableId();
            
            const currProjectCnt = projectRedux.voucherCounts[pvModel.project];
            await dispatch(
                addPaymentVoucher(
                    {   ...pvModel, 
                        'itemDetails': pvItems,
                        'serialNo' : sNo,
                        'voucherNo' : generateVoucherNo(sNo),
                        'createdDate' : currentDateLocale(),
                        'totalAmount' : totalAmount,
                        'bank' : (bank && bank !== 'Select Bank') ? bank : '',
                        'voucherDateStr' : dateAsLocaleString(pvModel.voucherDate),
                        'voucherDate' : null,//serializable objects encouraged to be saved in redux persist
                        'projectVSNo' : currProjectCnt + 1
                    }
                )
            );

            await dispatch(
                updateProjectVoucherCount(
                    
                        pvModel.project
                   
                )
            )
    
            setSuccessMessage('Payment Voucher Created Successfully');
            
            await delay(5000);
    
            resetStates();
        }
        else{
            setErrorMessage('There are some missing information');
            await delay(5000);
            setErrorMessage('');
        }
        
        
    }

   

    useEffect(() => {
        setShowNewItem(true);
    }, [pvItems])
   

    return (
        <Container>
        <Wrapper>
            {successMessage && 
                <SuccessMessageBox color='teal'>
                    {successMessage}
                </SuccessMessageBox>
            }

            {errorMessage && 
                <SuccessMessageBox color='red'>
                    {errorMessage}
                </SuccessMessageBox>
            }
          <Title>Create a Payment Voucher</Title>
          <Form>
            <FormRow>
                <FormRowTitle>
                    Voucher Date
                </FormRowTitle>
                <DateContainer>
                    <StyledDatePicker
                        name = "voucherDate"
                        selected={ pvModel.voucherDate }
                        onChange={ (date) => handleInputChange({ target: { value: date, name: 'voucherDate' } }) }
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={20}
                        timeCaption="time"
                        dateFormat="MMMM d, yyyy h:mm aa"
                    />
                </DateContainer>
                
            </FormRow>
            <FormRow>
                <FormRowTitle>Department</FormRowTitle>
                <DropDownSelect 
                    name = 'dept'
                    value = {pvModel.dept}
                    onChange = {(e) => handleInputChange(e)}>
                    <DropDownOption key = '0'>Select Department</DropDownOption>
                    {dept?.departments?.map((item) => (
                        <DropDownOption key = {item.deptId}>{item.deptName}</DropDownOption>
                    ))}
                    
                </DropDownSelect>
            </FormRow>
            <FormRow>
                <FormRowTitle>Section</FormRowTitle>
                <DropDownSelect 
                    name = 'section'
                    value = {pvModel.section}
                    onChange = {(e) => handleInputChange(e)}>
                    <DropDownOption key = '0'>Select Section</DropDownOption>
                    {sectionRedux?.sections?.map((item) => (
                        <DropDownOption key = {item.sectionId}>{item.sectionName}</DropDownOption>
                    ))}
                    
                </DropDownSelect>
            </FormRow>
            <FormRow>
                <FormRowTitle>Location</FormRowTitle>
                <DropDownSelect 
                    name = 'location'
                    value = {pvModel.location}
                    onChange = {(e) => handleInputChange(e)}>
                    <DropDownOption key = '0'>Select Location</DropDownOption>
                    {locationRedux?.locations?.map((item) => (
                        <DropDownOption key = {item.locationId}>
                            {item.locationName}
                        </DropDownOption>
                    ))}
                    
                </DropDownSelect>
            </FormRow>
            <FormRow>
                <FormRowTitle>Project</FormRowTitle>
                <DropDownSelect 
                    name = 'project'
                    value = {pvModel.project}
                    onChange = {(e) => handleInputChange(e)}>
                    <DropDownOption key = '0'>Select Project</DropDownOption>
                    {projectRedux?.projects?.map((item) => (
                        <DropDownOption key = {item.projectId}>{item.projectName}</DropDownOption>
                    ))}
                    
                </DropDownSelect>
            </FormRow>
            <FormRow>
            <FormRowTitle>Payee</FormRowTitle>
            <DropDownSelect
                name = 'payee'
                value = {pvModel.payeeId}
                onChange = {(e) => handleInputChange(e)}>
                <DropDownOption key= '0'>
                    Select Payee
                </DropDownOption>
                
                {payeeRedux?.payees?.map((item) => (
                    <DropDownOption key = {item.payeeId} value={item.payeeId}>
                        {item.payeeName}
                    </DropDownOption>
                ))}
            </DropDownSelect>
            </FormRow>
            <FormRow>
            <FormRowTitle>Payment Mode</FormRowTitle>
            <DropDownSelect
                name = 'paymode'
                value = {pvModel.paymode}
                onChange = {(e) => handleInputChange(e)}>
                <DropDownOption key='0'>Select Payment Mode</DropDownOption>
                <DropDownOption key='1'>Transfer</DropDownOption>
                <DropDownOption key='2'>Cheque</DropDownOption>
                <DropDownOption key='3'>Cash</DropDownOption>
                <DropDownOption key='4'>Card</DropDownOption>
            </DropDownSelect>
            </FormRow>
            <FormRow>
                <FormRowTitle>Bank</FormRowTitle>
                <DropDownSelect
                    name = 'bank'
                    value = {acctDetails.bank}
                    onChange = {(e) => handleInputChange(e)}>
                    <DropDownOption key= '0'>
                        Select Bank
                    </DropDownOption>
                    
                    {bankRedux?.banks?.map((item) => (
                        <DropDownOption key = {item.bankId}>
                            {item.bankName}
                        </DropDownOption>
                    ))}
                </DropDownSelect>
            </FormRow>
            <FormRow>
                <FormRowTitle>Account No.</FormRowTitle>
                <InputContainer style={{margin: 0}}>
                    <Input style={{margin: 0}}
                        placeholder="Enter Account Number"
                        name = 'acctno'
                        value = {acctDetails.acctno}
                        onChange = {(e) => handleInputChange(e)} 
                        />
                </InputContainer>
               
            </FormRow>
            
            {pvItems?.map((item, index) => (
                <FormRow key={index}>
                    <FormRowTitle>Item Details</FormRowTitle>
                    <InputContainer>
                    <Input 
                        
                        value = {item?.itemdesc}
                        disabled 
                        />
                    <Input 
                        
                        value = {item?.itemamount}
                        disabled
                        />
                    <Remove 
                        onClick={() => handleItemRemove({index})}
                        style = {{width: '20px', height: '20px' }}
                         
                        />
                    </InputContainer>
                </FormRow>
            ))}

            {showNewItem && <FormRow>
                    <FormRowTitle>Item Details</FormRowTitle>
                    
                    <InputContainer>
                    <Input 
                        placeholder="Item Description"
                        name = 'itemdesc'
                        value = {currItem?.itemdesc}
                        onChange = {(e) => handleItemChange(e)} 
                        />
                    <Input 
                        placeholder="Amount"
                        name = 'itemamount'
                        value = {currItem?.itemamount}
                        onChange = {(e) => handleItemChange(e)}
                        />
                    <Add 
                        onClick={(e) => handleItemAdd(e)}
                        style = {{width: '20px', height: '20px'}}
                         
                        />
                    </InputContainer>
                    
                </FormRow>
            }
            
            
            
            
            
          </Form>
          <Button
                onClick={(e) => handleSubmit(e)}>
                CREATE PV
            </Button>
        </Wrapper>
      </Container>
    )
}

export default CreateVoucher
